package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.Comment
import com.example.readingnotes.domain.repository.CommentRepository
import com.example.readingnotes.util.Result

class CreateCommentUseCase(
    private val commentRepository: CommentRepository,
) {
    suspend operator fun invoke(
        postId: Int,
        authorName: String?,
        content: String,
    ): Result<Comment> {
        // Client-side validation
        if (content.isBlank()) {
            return Result.failure(IllegalArgumentException("コメントを入力してください"))
        }
        if (content.length > 1000) {
            return Result.failure(IllegalArgumentException("コメントは1000文字以内で入力してください"))
        }
        if (authorName != null && authorName.length > 100) {
            return Result.failure(IllegalArgumentException("名前は100文字以内で入力してください"))
        }

        return commentRepository.createComment(postId, authorName, content)
    }
}
